import { Award, Clock, Headphones, ShieldCheck } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, title: "Garanzie chiare", text: "Garanzia del produttore su moduli e inverter e garanzia sulla posa, messe nero su bianco nel contratto." },
  { icon: Award, title: "Certificazioni", text: "Installatori abilitati ai sensi del D.M. 37/08 e impianti conformi alle norme CEI per la connessione in rete." },
  { icon: Clock, title: "Tempi rapidi", text: "Proposta in 48 ore dal sopralluogo e cronoprogramma condiviso prima dell'avvio dei lavori." },
  { icon: Headphones, title: "Assistenza dedicata", text: "Un unico referente per pratiche, installazione e supporto dopo l'attivazione." },
];

export const WhyUs = () => (
  <section id="perche-noi" className="bg-white py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-4">
        <span className="eyebrow">Perché sceglierci</span>
        <h2 className="section-title mt-5">Qualità che si vede, risultati che si misurano.</h2>
      </div>
      <div className="grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:col-span-7 lg:col-start-6">
        {ITEMS.map((it) => (
          <div key={it.title} data-testid={`why-item-${it.title.toLowerCase().replace(/\s/g, "-")}`} className="border-t border-slate-200 pt-6">
            <it.icon className="h-7 w-7 text-emerald-600" />
            <h3 className="mt-4 text-xl font-semibold text-slate-900">{it.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{it.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
